import type { HttpInterceptorFn } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ENV_CONFIG } from '@core/config/environment.token';
import { AuthSessionNavigationService } from '@core/auth/auth-session-navigation.service';
import { AuthSessionStateService } from '@core/auth/auth-session-state.service';
import { hasHttpStatus } from '@core/http/http-status.util';
import { apiPath, isAuthPath } from './api-request-policy';

/** 401 = session terminée : seule cette réponse déconnecte, jamais une erreur transitoire. */
export const sessionExpiredInterceptor: HttpInterceptorFn = (req, next) => {
  const env = inject(ENV_CONFIG);
  const document = inject(DOCUMENT);
  const path = apiPath(req.url, env.api.baseUrl, document.baseURI);
  if (path === null || isAuthPath(path)) return next(req);
  const state = inject(AuthSessionStateService);
  const navigation = inject(AuthSessionNavigationService);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (hasHttpStatus(error, 401) && state.session() !== null) {
        state.invalidate();
        navigation.redirectToLogin();
      }
      return throwError(() => error);
    })
  );
};
